import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import Logo from '@/components/ui/logo'

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-accent/5 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-center mb-8">
          <div className="flex items-center space-x-3">
            <div className="bg-gradient-to-r from-primary to-primary-glow p-3 rounded-full shadow-glow">
              <Logo className="h-8 w-8" />
            </div>
            <h1 className="text-3xl font-bold bg-gradient-to-r from-primary to-primary-glow bg-clip-text text-transparent">
              Datenschutzerklärung
            </h1>
          </div>
        </div>

        <Card className="shadow-soft border-0 bg-card/80 backdrop-blur-sm">
          <CardHeader>
            <CardTitle className="text-2xl">Datenschutzerklärung</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold mb-3">1. Datenschutz auf einen Blick</h3>
              <div className="space-y-3 text-sm text-muted-foreground">
                <h4 className="font-medium text-foreground">Allgemeine Hinweise</h4>
                <p>
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
                  passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
                  persönlich identifiziert werden können.
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">2. Verantwortlicher</h3>
              <div className="space-y-1 text-muted-foreground">
                <p className="font-medium text-foreground">Maximilian Schüller</p>
                <p>Michelsgrundweg 11</p>
                <p>97702 Münnerstadt</p>
                <p>Deutschland</p>
                <p><span className="font-medium text-foreground">Telefon:</span> 015738754718</p>
                <p><span className="font-medium text-foreground">E-Mail:</span> kontakt@herzensempfehlung.de</p>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">3. Datenerfassung auf dieser Website</h3>
              
              <div className="space-y-4 text-sm text-muted-foreground">
                <div>
                  <h4 className="font-medium text-foreground mb-2">Welche Daten werden erhoben?</h4>
                  <p>Wir erheben folgende personenbezogene Daten:</p>
                  <ul className="list-disc list-inside ml-4 space-y-1 mt-2">
                    <li>E-Mail-Adresse (bei Registrierung und Kontaktaufnahme)</li>
                    <li>Name (bei Registrierung)</li>
                    <li>Kontaktdaten wie Handy- oder Festnetznummer (bei freiwilliger Angabe)</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-medium text-foreground mb-2">Wofür nutzen wir Ihre Daten?</h4>
                  <p>Die Daten werden verwendet für:</p>
                  <ul className="list-disc list-inside ml-4 space-y-1 mt-2">
                    <li>Bereitstellung des Treuekarten-Services</li>
                    <li>Verwaltung Ihres Kundenkontos</li>
                    <li>Kommunikation bezüglich des Services</li>
                    <li>Abwicklung von Empfehlungen und Belohnungen</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-medium text-foreground mb-2">Rechtsgrundlage</h4>
                  <p>
                    Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) und 
                    zur Erfüllung des Vertrags (Art. 6 Abs. 1 lit. b DSGVO).
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">4. Cookies und Tracking</h3>
              <div className="space-y-3 text-sm text-muted-foreground">
                <p>
                  Diese Website verwendet Cookies zur Verbesserung der Nutzererfahrung. Cookies werden durch unser 
                  integriertes Cookie-Management-System verwaltet. Sie können Ihre Cookie-Einstellungen jederzeit 
                  über die Cookie-Einstellungen anpassen.
                </p>
                <p>
                  Wir verwenden keine externen Tracking-Tools wie Google Analytics oder ähnliche Dienste.
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">5. Hosting und Datenverarbeitung</h3>
              <div className="space-y-3 text-sm text-muted-foreground">
                <p>
                  Diese Website wird über Lovable gehostet. Alle Daten werden sicher verarbeitet und gespeichert. 
                  Die technische Infrastruktur entspricht modernen Sicherheitsstandards.
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">6. Ihre Rechte</h3>
              <div className="space-y-3 text-sm text-muted-foreground">
                <p>Sie haben folgende Rechte:</p>
                <ul className="list-disc list-inside ml-4 space-y-1 mt-2">
                  <li>Recht auf Auskunft über Ihre gespeicherten Daten</li>
                  <li>Recht auf Berichtigung unrichtiger Daten</li>
                  <li>Recht auf Löschung Ihrer Daten</li>
                  <li>Recht auf Einschränkung der Verarbeitung</li>
                  <li>Recht auf Datenübertragbarkeit</li>
                  <li>Widerspruchsrecht gegen die Verarbeitung</li>
                  <li>Beschwerderecht bei einer Aufsichtsbehörde</li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">7. Kontakt für Datenschutzanfragen</h3>
              <div className="space-y-1 text-muted-foreground">
                <p>Bei Fragen zum Datenschutz wenden Sie sich an:</p>
                <p className="mt-2">
                  <span className="font-medium text-foreground">E-Mail:</span> kontakt@herzensempfehlung.de<br />
                  <span className="font-medium text-foreground">Telefon:</span> 015738754718
                </p>
              </div>
            </div>

            <div className="pt-4 border-t">
              <p className="text-xs text-muted-foreground">
                Stand: {new Date().toLocaleDateString('de-DE', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default Datenschutz